<template>
    <b-modal v-model="show" title="ГОСКОМСТАТ ИНДЕКСИ">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="date">{{$t('common.date')}} <span class="red">*</span></label>
                        <date-picker class="form-control"
                                     id="date"
                                     v-model="data.date"
                                     format="dd/MM/yyyy"
                                     :class="{'is-invalid':$v.data.date.$error}"
                        ></date-picker>
                        <div class="red" v-if="$v.data.date.$error">Санани киритинг</div>
                    </div>
                    <div class="form-group">
                        <label>Индекс <span class="red">*</span></label>
                        <numeric-input v-model="data.coefficient"
                                       :precision="3"
                                       :class="{invalid:$v.data.coefficient.$error}"
                        ></numeric-input>
                        <div class="red" v-if="$v.data.coefficient.$error">Индексни киритинг</div>
                    </div>
                    <div class="form-group">
                        <label for="category">Қурилиш тури </label>
                        <select name="category" id="category"
                                v-model="data.category"
                                class="form-control">
                            <option value="brick">Пишган ғишт</option>
                            <option value="panel">Панел бетон</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Вилоятни танланг <span class="red">*</span></label>
                        <v-select v-model="data.province"
                                  label="name"
                                  :filterable="false"
                                  :options="provinces"
                                  @change="onChangeProvince"
                                  :class="{invalid: $v.data.province.id.$error}"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.data.province.id.$error">Туманни танланг</div>
                    </div>
                    <div class="form-group">
                        <label>Туманни танланг</label>
                        <v-select v-model="data.region"
                                  label="name"
                                  :options="regions"
                                  :filterable="false"
                                  @search="onRegionSearch"
                                  @search:focus="onRegionFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <div class="form-check pl-0">
                            <label class="form-check-label" style="padding-left:22px !important">
                                <input class="form-check-input" type="checkbox"
                                       v-model="data.active">
                                <span class="form-check-sign"></span>
                                Холати
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_CAD_BUILDING_INDEX_ADD')" @click="save">{{$t('action.save')}}</button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">{{$t('action.cancel')}}</button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import DatePicker from 'vuejs-datepicker';
    import {clone} from '@/shared/utils';
    import { required, minValue } from 'vuelidate/lib/validators'
    import initFilterModel from '@/shared/filter';

    export default {
        name: "CadastreBuildingIndexEditModal",
        components: {
            'b-modal': bModal,
            DatePicker
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                data: this.emptyData(),
                provinces: [],
                regions: []
            }
        },
        validations() {
            return {
                data: {
                    date: {
                        required: required
                    },
                    coefficient: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    province: {
                        id: {
                            required: required
                        }
                    }
                }
            }
        },
        methods:{
            emptyData() {
               return {
                   date: null,
                   coefficient: null,
                   category: null,
                   province: {},
                   region: {},
                   active: true
               }
            },
            initData() {
                const vm = this;
                vm.provinces = [];
                vm.filterProvince.search = '';
                this.$http.post('/province/list', vm.filterProvince)
                    .then(res => {
                        vm.provinces = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;

                this.$http.post('cadastre/building/index/save',this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('cadastreBuildingIndexChanged', response);
                        }
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    })
            },
            onChangeProvince() {
                if (this.regions.length > 0) {
                    this.data.region = {};
                }
            },
            cancel() {
               this.show = false;
            },
            getAsMaps(result) {
                if (result && result.data && result.data.length > 0) {
                    return result.data.map(d =>({id: d.id, name: d.name}))
                }
                return [];
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.data.province && this.data.province.id) ? this.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.data.province && this.data.province.id) ? this.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
        },
       created() {
           this.filterProvince.page.size = 1000;
           this.filterRegion.page.size = 1000;
           this.initData();
           this.$eventBus.$on('showCadastreBuildingIndexModal', (data) => {
               if (data) {
                   this.data = clone(data);
               } else this.data = this.emptyData();
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>